module.exports = __webpack_public_path__ + "static/img/yzww.4a5425a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/yzww.png
// module id = Soz8
// module chunks = 0